"use strict";

define('rs/models/pdf',['rs/models/abstract', 'jquery', 'underscore', 'e3-modal'], function (AbstractModel, $, _, E3Modal) {
  var PDFGenerator = AbstractModel.extend({}, {
    stringifyInput: function stringifyInput(input) {
      var outputHtml = "",
        bodyEl = document.createElement('body');
      if (input instanceof $) {
        input = input.get(0);
      }
      if (_.isString(input)) {
        bodyEl.innerHTML = input;
      } else if (_.isElement(input)) {
        if (input.tagName == "BODY") {
          bodyEl = input;
        } else {
          bodyEl.appendChild(input);
        }
      }
      outputHtml = bodyEl.outerHTML;
      return outputHtml;
    },
    displayPdfDownloadErrorModal: function displayPdfDownloadErrorModal() {
      E3Modal.BtnMsgModal.show({
        title: 'Error',
        message: 'The file size exceeds the processing limit. Please reach out to support for more information.',
        buttons: ['OK']
      });
    },
    requestCreatePDF: function requestCreatePDF(input, externalWindow) {
      var MAX_HTML_CONTENT_SIZE = 15 * 1024 * 1024,
        currentHtml = this.stringifyInput(input),
        currentHtmlSize = currentHtml === null || currentHtml === void 0 ? void 0 : currentHtml.length;
      if (currentHtmlSize > MAX_HTML_CONTENT_SIZE) {
        this.displayPdfDownloadErrorModal();
        externalWindow.close();
      } else {
        var windoc = externalWindow ? externalWindow.document : window.document;
        var IS_CHROME = String(navigator.userAgent).toLowerCase().indexOf('chrome') !== -1;
        var pdfForm = windoc.createElement("form"),
          html = this.stringifyInput(input),
          data = {},
          url = '/rs/api/pdf/create';
        if (externalWindow) {
          url = window.location.protocol + "//" + window.location.host + url;
        }
        data = {
          html: html,
          downloadForChrome: IS_CHROME,
          '_csrf': window._csrf_token
        };
        pdfForm.setAttribute("accept-charset", 'UTF-8');
        pdfForm.setAttribute("action", url);
        pdfForm.setAttribute("method", "POST");
        pdfForm.setAttribute("target", externalWindow ? "_self" : "_blank");
        for (key in data) {
          var element = windoc.createElement("input");
          element.setAttribute("type", "hidden");
          element.setAttribute("name", key);
          element.setAttribute("value", data[key]);
          pdfForm.appendChild(element);
        }
        var submitEl = windoc.createElement('input');
        submitEl.setAttribute('type', 'submit');
        submitEl.setAttribute('value', 'Submit');
        pdfForm.appendChild(submitEl);
        windoc.body.appendChild(pdfForm);
        $(pdfForm).trigger('submit');
        windoc.body.removeChild(pdfForm);
      }
    },
    generatePopup: function generatePopup() {
      var IS_CHROME = String(navigator.userAgent).toLowerCase().indexOf('chrome') !== -1;
      if (!IS_CHROME) {
        var wi = window.open('about:blank', '_blank');
        wi.document.title = "Loading...";
        wi.document.body.innerHTML = "<pre>Loading...</pre>";
        return wi;
      } else return window.open();
    }
  });
  return PDFGenerator;
});

